import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
var y_date = {
  //补零
  formatNum: function formatNum(num) {
    num = ~~num;
    return num < 10 ? 0 + '' + num : num;
  },
  //组装年日月
  //接受[2018, 6, 20]，或(2018, 6, 20)
  //返回yyyy-MM-dd格式日期
  getYMD: function getYMD() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var len = args.length;
    if (1 === len) {
      return args[0][0] + '-' + y_date.formatNum(~~args[0][1]) + '-' + y_date.formatNum(~~args[0][2]);
    } else if (3 === len) {
      return args[0] + '-' + y_date.formatNum(~~args[1]) + '-' + y_date.formatNum(~~args[2]);
    } else {
      return y_date.getCurDate();
    }
  },
  // 获取当前年、月、日
  getCurDate: function getCurDate(type, sign) {
    sign = sign || '-';
    var date = new Date(),
      year = date.getFullYear(),
      month = y_date.formatNum(date.getMonth() + 1),
      day = y_date.formatNum(date.getDate()),
      str = year + sign + month + sign + day;
    if (type === 'y') {
      str = year;
    } else if (type === 'm') {
      str = month;
    } else if (type === 'd') {
      str = day;
    }
    return str;
  },
  //格式化时间
  //输入 时间戳、是否显示时分秒、分隔符
  //默认输出当前年日月
  formatTime: function formatTime(date, hms, splits) {
    var d_len = date ? date.toString().length : 0,
      n_num = Number(date),
      n_res = n_num ? d_len !== 13 ? Number(date + '000') : n_num : date;
    date = n_res ? new Date(n_res) : '';
    splits = splits || '-';
    hms = hms || false;
    if (!date) {
      date = new Date();
    }
    var year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate(),
      hour = date.getHours(),
      minute = date.getMinutes(),
      second = date.getSeconds(),
      dates = [year, month, day].map(y_date.formatNum).join(splits),
      times = hms ? ' ' + [hour, minute, second].map(y_date.formatNum).join(':') : '';
    return dates + times;
  },
  //获取某月天数，默认返回当月天数
  getDayNum: function getDayNum() {
    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getFullYear();
    var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getMonth() + 1;
    y = ~~y;
    m = ~~m;
    var date = new Date(y + '-' + y_date.formatNum(m) + '-01');
    date.setMonth(m);
    date.setDate(0);
    return date.getDate();
  },
  //是否今天，可传2018-06-20或2018,6,1
  isToday: function isToday() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var len = args.length,
      cDate = new Date(y_date.getCurDate()).getTime();
    if (1 === len) {
      return new Date(args[0]).getTime() === cDate;
    } else if (3 === len) {
      return new Date(y_date.getYMD(args)).getTime() === cDate;
    }
    return false;
  },
  //距离月数
  //d1: 起始日期 2018-06-20
  //d2: 结束日期 2018-08-20
  //return 2
  //默认都是当月第1天
  monthDistance: function monthDistance(d1, d2) {
    var arr1 = d1.split('-').map(function (i) {
        return ~~i;
      }),
      arr2 = d2.split('-').map(function (i) {
        return ~~i;
      });
    return (arr2[0] - arr1[0]) * 12 + arr2[1] - arr1[1];
  },
  //距离天数
  //d1: 起始日期 2018-06-20
  //d2: 结束日期 2018-06-22
  //return 2
  dayDistance: function dayDistance(d1, d2) {
    var date1 = new Date(d1),
      date2 = new Date(d2);
    return (date2 - date1) / 24 / 60 / 60 / 1000;
  },
  //获取上个月份
  getLastMonth: function getLastMonth(y, m) {
    y = ~~y;
    m = ~~m;
    if (1 >= m) {
      return [y - 1, 12];
    } else {
      return [y, m - 1];
    }
  },
  //获取下个月份
  getNextMonth: function getNextMonth(y, m) {
    y = ~~y;
    m = ~~m;
    if (12 <= m) {
      return [y + 1, 1];
    } else {
      return [y, m + 1];
    }
  },
  //获取某月行数，默认当月
  getMonthLine: function getMonthLine() {
    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getFullYear();
    var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getMonth() + 1;
    var firstDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    y = ~~y;
    m = ~~m;
    var date = new Date(y + '-' + y_date.formatNum(m) + '-01'),
      day = y_date.getDayNum(y, m);
    return Math.ceil(((date.getDay() + 7 - firstDay) % 7 + day) / 7);
  },
  //获取n天后日期
  //可传入(2018,6,20,3)，返回2018-06-23
  //可传入(2018-06-20,-3)，返回2018-06-17
  getAfterDate: function getAfterDate() {
    var len = arguments.length;
    if (2 === len) {
      return y_date.formatTime(new Date(arguments.length <= 0 ? undefined : arguments[0]).getTime() + ~~(arguments.length <= 1 ? undefined : arguments[1]) * 24 * 60 * 60 * 1000);
    } else if (4 === len) {
      return y_date.formatTime(new Date(y_date.getYMD(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2])).getTime() + ~~(arguments.length <= 3 ? undefined : arguments[3]) * 24 * 60 * 60 * 1000);
    }
  },
  extend: function extend() {
    function isObj(x) {
      var type = _typeof(x);
      return x !== null && (type === 'object' || type === 'function');
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return Object(val);
    }
    function assignKey(to, from, key) {
      var val = from[key];
      if (val === undefined || val === null) {
        return;
      }
      if (hasOwnProperty.call(to, key)) {
        if (to[key] === undefined || to[key] === null) {
          throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
        }
      }
      if (!hasOwnProperty.call(to, key) || !isObj(val)) {
        to[key] = val;
      } else {
        to[key] = assign(Object(to[key]), from[key]);
      }
    }
    function assign(to, from) {
      if (to === from) {
        return to;
      }
      from = Object(from);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          assignKey(to, from, key);
        }
      }
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            assignKey(to, from, symbols[i]);
          }
        }
      }
      return to;
    }
    function deepAssign(target) {
      target = toObject(target);
      for (var s = 1; s < arguments.length; s++) {
        assign(target, arguments[s]);
      }
      return target;
    }
    return deepAssign;
  },
  //实现类似Object.assign的功能
  assign: function assign() {
    return y_date.extend().apply(void 0, arguments);
  },
  //生成年日历json
  createYear: function createYear(opts) {
    var options = {
        year: new Date().getFullYear(),
        //年
        month: 1,
        otherMonth: false,
        //是否显示其他月份
        firstDay: 0 //开始星期
      },
      dateArr = [];
    y_date.assign(options, opts);
    for (var i = 0; i < 12; i++) {
      var month = y_date.getNextMonth(options.year, options.month);
      dateArr.push(y_date.createDate(options));
      options.year = month[0];
      options.month = month[1];
    }
    return dateArr;
  },
  //生成月日历json
  createMonths: function createMonths(opts) {
    var options = {
        year: new Date().getFullYear(),
        //年
        month: 1,
        otherMonth: false,
        //是否显示其他月份
        firstDay: 0,
        //开始星期
        num: 3 //生成月分数，默认为3
      },
      dateArr = [];
    y_date.assign(options, opts);
    for (var i = 0; i < options.num; i++) {
      var month = y_date.getNextMonth(options.year, options.month);
      dateArr.push(y_date.createDate(options));
      options.year = month[0];
      options.month = month[1];
    }
    return dateArr;
  },
  //生成日历json
  //输入年、月，默认不显示其他月份的日历
  //默认返回当前月份日历
  createDate: function createDate(opts) {
    var options = {
      year: new Date().getFullYear(),
      //年
      month: new Date().getMonth() + 1,
      //月
      otherMonth: false,
      //是否显示其他月份
      firstDay: 0 //开始星期
    };

    y_date.assign(options, opts);
    var y = options.year,
      m = options.month,
      firstDay = options.firstDay,
      otherMonth = options.otherMonth,
      dayNum = y_date.getDayNum(y, m),
      line = y_date.getMonthLine(y, m, firstDay),
      dateArr = function () {
        var arr = [];
        for (var i = 0; i < line; i++) {
          var arrIn = [];
          for (var j = 0; j < 7; j++) {
            arrIn.push({});
          }
          arr.push(arrIn);
        }
        return arr;
      }(),
      lineCount = 0;
    for (var i = 0; i < dayNum; i++) {
      var d = i + 1,
        date = new Date(y, m - 1, d),
        day = d,
        week = date.getDay(),
        weekSort = (7 + week - firstDay) % 7,
        format = y_date.getYMD(y, m, d),
        isToday = y_date.isToday(y, m, d);
      dateArr[lineCount][weekSort] = {
        year: y,
        month: y_date.formatNum(m),
        day: day,
        week: week,
        //0-星期日......6-星期六
        format: format,
        isToday: isToday
      };
      if (6 === weekSort) {
        lineCount++;
      }
    }

    //插入其他月份日期
    if (otherMonth) {
      var dateStart = new Date(y, m - 1, 1),
        dateEnd = new Date(y, m - 1, dayNum),
        weekStartBlank = (7 + dateStart.getDay() - firstDay) % 7,
        weekEndDay = (7 + dateEnd.getDay() - firstDay) % 7,
        weekEndBlank = 6 - weekEndDay,
        lastMonth = y_date.getLastMonth(y, m),
        nextMonth = y_date.getNextMonth(y, m),
        ly = lastMonth[0],
        lm = lastMonth[1],
        ny = nextMonth[0],
        nm = nextMonth[1],
        lastDayNum = y_date.getDayNum(lastMonth[0], lastMonth[1]);

      //补全上月日期
      for (var _i = weekStartBlank - 1, j = 0; _i >= 0; _i--, j++) {
        var lastDay = new Date(ly, lm - 1, lastDayNum - j),
          _week = lastDay.getDay(),
          _day = lastDayNum - j,
          _format = y_date.getYMD(ly, lm, _day);
        dateArr[0][_i] = {
          year: ly,
          month: y_date.formatNum(nm),
          day: _day,
          week: _week,
          //0-星期日......6-星期六
          format: _format,
          isLastMonth: true,
          isOtherMonth: true
        };
      }

      //补全下月日期
      for (var _i2 = 0; _i2 < weekEndBlank; _i2++) {
        var _lastDay = new Date(ny, nm - 1, _i2 + 1),
          _week2 = _lastDay.getDay(),
          _day2 = _i2 + 1,
          _format2 = y_date.getYMD(ny, nm, _day2);
        dateArr[line - 1][_i2 + weekEndDay + 1] = {
          year: ny,
          month: y_date.formatNum(nm),
          day: _day2,
          week: _week2,
          //0-星期日......6-星期六
          format: _format2,
          isNextMonth: true,
          isOtherMonth: true
        };
      }
    }
    return {
      year: options.year,
      month: y_date.formatNum(options.month),
      content: dateArr
    };
  },
  /*
   * Date对象转字符串
   * @param date 要转换的Date对象
   * @param pattern 字符串格式模板，其中字符"y"、"M"、"d"、"h"、"m"、"s"、"w"、"q"、"S"会被替代成日期对应的数值，长度由字符数决定
   * @return 满足pattern格式的字符串
   * 例：
   * pattern 为 "yyyy-MM-dd"，则返回如 "2015-08-18"
   * pattern 为 "yyyy-MM-dd hh:mm:ss"，则返回如 "2015-08-18 09:41:13"
   * pattern 为 "yyyy-MM-dd hh:mm:ss"，则返回如 "2015-08-18 09:41:13"
   * pattern 为 "yyyy-MM-dd hh:mm:ss +(S)"，则返回如 "2015-08-18 09:43:44 +(902)"
   * pattern 为 "yy年第q季度"，则返回如 "15年第3季度"
   * pattern 为 "今天是星期w"，则返回如 "今天是星期二"
   * */
  dateToStr: function dateToStr(date, pattern) {
    if ('string' === typeof date) {
      return date;
    }
    pattern = pattern || 'yyyy-MM-dd';
    var o = {
      "M+": date.getMonth() + 1,
      //month 从 Date 对象返回月份 (0 ~ 11)，加以改成1~12月份
      "d+": date.getDate(),
      //day 从 Date 对象返回一个月中的某一天 (1 ~ 31)。
      "h+": date.getHours(),
      //hour 返回 Date 对象的小时 (0 ~ 23)。
      "m+": date.getMinutes(),
      //minute  返回 Date 对象的分钟 (0 ~ 59)。
      "s+": date.getSeconds(),
      //second 返回 Date 对象的秒数 (0 ~ 59)。
      "w+": "\u65E5\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D".charAt(date.getDay()),
      //“日一二三四五六”中的某一个
      "q+": Math.floor((date.getMonth() + 3) / 3),
      //季度
      "S": date.getMilliseconds() //Date 对象的毫秒(0 ~ 999)。
    };

    //将"yyyy-MM-dd"中的"y"替换成具体年份，并根据"y"的数量保留对应的位数
    if (new RegExp("(y+)").test(pattern)) {
      pattern = pattern.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    //替换剩下的模板，如果有的模板长度大于1，如"yyyy-MM-dd"中的"MM"、"dd"，则定为两位，实际字符串长度不足两位的，前面用0补足
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(pattern)) {
        pattern = pattern.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return pattern;
  },
  //比较两个日期相差天数
  compareDate: function compareDate(date1, date2) {
    if (!date1) {
      return false;
    }
    if (!date2) {
      date2 = y_date.getCurDate();
    }
    return (new Date(date1) - new Date(date2)) / (24 * 3600 * 1000);
  },
  //格式化时间，返回会Date类型数据
  formatDate: function formatDate(arg) {
    arg = arg + '';
    var dateFunc = function dateFunc(arg) {
        var arr = [];
        arr = arg.replace(/\//g, '-').split('-');
        return arr[0] + '-' + y_date.formatNum(arr[1]) + '-' + y_date.formatNum(arr[2]);
      },
      timeFunc = function timeFunc(arg) {
        var arr = [];
        arr = arg.split(':');
        return y_date.formatNum(arr[0]) + ':' + y_date.formatNum(arr[1]) + ':' + y_date.formatNum(arr[2]);
      };
    if ('object' === _typeof(arg)) {
      return arg;
    }

    //输入2018-04-05 12:45:22 类型的
    if (isNaN(Number(arg))) {
      var dateString = '',
        timeString = '';
      if (/ /.test(arg)) {
        var arr = arg.split(' ');
        dateString = dateFunc(arr[0]);
        timeString = ' ' + timeFunc(arr[1]);
      } else {
        dateString = dateFunc(arg);
      }
      return new Date(dateString + timeString);
    } else {
      //输入时间戳
      return new Date(Number(arg.length !== 13 ? arg + '000' : arg));
    }
  },
  //倒计时，可输入天数、日期，object参数，返回object
  countdown: function countdown(opts) {
    var countDay = 0,
      date = '',
      nowDate = new Date(),
      options = {
        dimension: 'day',
        //维度，默认是天，枚举值：'year','month','day'
        targetDate: ''
      },
      year = '00',
      month = '00',
      day = '00',
      hour = '00',
      minute = '00',
      second = '00',
      milliseconds = '00',
      dimension,
      isOver = false;
    if ('string' === typeof opts) {
      date = opts;
    } else {
      y_date.assign(options, opts);
      date = options.targetDate;
    }
    countDay = y_date.formatDate(date) - nowDate + nowDate.getTimezoneOffset() * 60 * 1000;
    dimension = options.dimension;
    if (countDay > 0) {
      if ('year' === dimension) {
        year = ~~(countDay / 1000 / 60 / 60 / 24 / 365);
        month = ~~(countDay / 1000 / 60 / 60 / 24 / 30 - year * 12);
      }
      if ('month' === dimension) {
        year = 0;
        month = ~~(countDay / 1000 / 60 / 60 / 24 / 30 - year * 12);
      }
      if ('day' === dimension) {
        year = 0;
        month = 0;
      }
      day = ~~(countDay / 1000 / 60 / 60 / 24 - year * 365 - month * 30);
      hour = ~~(countDay / 1000 / 60 / 60 - year * 365 * 24 - month * 30 * 24 - day * 24);
      minute = ~~(countDay / 1000 / 60 - year * 365 * 24 * 60 - month * 30 * 24 * 60 - day * 24 * 60 - hour * 60);
      second = ~~(countDay / 1000 - year * 365 * 24 * 60 * 60 - month * 30 * 24 * 60 * 60 - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60);
      milliseconds = ~~(countDay - year * 365 * 24 * 60 * 60 * 1000 - month * 24 * 30 * 60 * 60 * 1000 - day * 24 * 60 * 60 * 1000 - hour * 60 * 60 * 1000 - minute * 60 * 1000 - second * 1000);
    } else {
      isOver = true;
    }
    return {
      year: y_date.formatNum(year),
      month: y_date.formatNum(month),
      day: y_date.formatNum(day),
      hour: y_date.formatNum(hour),
      minute: y_date.formatNum(minute),
      second: y_date.formatNum(second),
      milliseconds: y_date.formatNum((milliseconds + '').slice(0, 2)),
      isOver: isOver
    };
  },
  //根据传入日期返回该日期所在日历行数
  getDateLine: function getDateLine(date) {
    var firstDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var dateObj = y_date.formatDate(date),
      dateStr = y_date.dateToStr(dateObj),
      day = ~~date.slice(8, 10),
      fisrt = new Date(date.slice(0, -2) + '01').getDay() - firstDay,
      line = Math.floor((day + fisrt) / 7),
      mod = (day + fisrt) % 7;
    return mod ? line : line - 1;
  }
};
function c() {
  var _console;
  (_console = console).log.apply(_console, arguments);
}
export default y_date;

/**修改
1.createDate返回值改为object
2.添加createYear和createMonths
**/